import './App.css';
import HomePage from './pages/home/home.component';

const App = () => (
  <HomePage />
)

export default App;
